// English message translations
export const messages = {
  // Common UI elements
  "Send": "Send",
  "Clear chat": "Clear chat",
  "Support": "Support",
  "Settings": "Settings",
  "Language": "Language",
  "Theme": "Theme",
  "Font Size": "Font Size",
  "Select language": "Select language",
  
  // Chat interface
  "Type your message...": "Type your message...",
  "Thinking...": "Thinking...",
  "Labor Law Expert": "Labor Law Expert",
  "by MJ": "by MJ",
  "Leen": "Leen",
  
  // Frameworks - keeping these for backward compatibility
  "Automatic detection": "Automatic detection",
  "Essential Cybersecurity Controls": "Essential Cybersecurity Controls",
  "Cloud Cybersecurity Controls": "Cloud Cybersecurity Controls",
  "Critical Systems Cybersecurity Controls": "Critical Systems Cybersecurity Controls",
  "Data Cybersecurity Controls": "Data Cybersecurity Controls",
  "Organizations' Social Media Accounts Cybersecurity Controls": "Organizations' Social Media Accounts Cybersecurity Controls",
  "Operational Technology Cybersecurity Controls": "Operational Technology Cybersecurity Controls",
  "Telework Cybersecurity Controls": "Telework Cybersecurity Controls",
  
  // Models
  "Claude by Anthropic": "Claude by Anthropic",
  "DeepSeek by Groq": "DeepSeek by Groq",
  "MJ Lab Mode": "MJ Lab Mode",
  
  // Messages
  "Language changed to {{locale}}": "Language changed to {{locale}}",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hello, I am {{name}}, an AI assistant made by MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "I am expert in labor laws and regulations for Saudi Arabia.",
  "Ask me a question, and I will gladly answer you.": "Ask me a question, and I will gladly answer you.",
  "Do not share confidential data.": "Do not share confidential data.",
  "I am powered using": "I am powered using",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Disclaimer:** {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.",
  
  // Error messages
  "An error occurred": "An error occurred",
  "Failed to change language": "Failed to change language",
  "Please try again": "Please try again",
  "Connection lost": "Connection lost",
  "Reconnecting...": "Reconnecting...",
  "Nothing to clear": "Nothing to clear",
  "All messages cleared": "All messages cleared",
  "All data cleared": "All data cleared",
  "Storage limit reached": "Storage limit reached",
  "Some older messages were removed to save space.": "Some older messages were removed to save space.",
  "Error": "Error",
  
  // Tooltips
  "Increase font size": "Increase font size",
  "Decrease font size": "Decrease font size",
  "Reset font size": "Reset font size",
  "Change theme": "Change theme",
  "Support the project": "Support the project",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} character left",
  "{{remainingChars}} characters left": "{{remainingChars}} characters left",
  
  // Message actions
  "Message copied to clipboard": "Message copied to clipboard",
  "Read": "Read",
  "Summarize": "Summarize",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Message Suggestions",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Select a question to quickly start a conversation about Saudi labor laws.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "What are the key employee rights under Saudi labor law? Can you provide a simple overview?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "How does Saudi labor law handle termination of employment and end-of-service benefits?",
  
  // Audio Player Dialog
  "AI Summary": "AI Summary",
  "Listen to the summarized response using our AI Service.": "Listen to the summarized response using our AI Service.",
  "Generating summary...": "Generating summary...",
  "Preparing audio...": "Preparing audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Failed to process text. Please try again.",
  "Failed to auto-play audio. Click play to try again.": "Failed to auto-play audio. Click play to try again.",
  "Failed to load audio. Please try again.": "Failed to load audio. Please try again.",
  "Audio playback was aborted.": "Audio playback was aborted.",
  "Network error occurred while loading audio.": "Network error occurred while loading audio.",
  "Audio decoding failed.": "Audio decoding failed.",
  "Audio format not supported.": "Audio format not supported.",
  "Failed to setup audio playback": "Failed to setup audio playback",
  "Failed to generate speech": "Failed to generate speech",
  "Failed to generate audio. Please try again.": "Failed to generate audio. Please try again.",
  "Failed to play audio. Please try again.": "Failed to play audio. Please try again.",
  
  // Update Notifications
  "update.updateAvailable": "Update Available",
  "update.newVersionAvailable": "New Version {{version}} Available",
  "update.refreshToApply": "Refresh to apply the latest features and improvements",
  "update.later": "Later",
  "update.updateNow": "Update Now",
  
  // CSAT Feedback
  "We Value Your Feedback": "We Value Your Feedback",
  "Give Feedback": "Give Feedback",
  "How would you rate your experience?": "How would you rate your experience?",
  "Very Dissatisfied": "Very Dissatisfied",
  "Dissatisfied": "Dissatisfied",
  "Neutral": "Neutral",
  "Satisfied": "Satisfied",
  "Very Satisfied": "Very Satisfied",
  "Select a rating": "Select a rating",
  "Comments or Bug Report": "Comments or Bug Report",
  "Please share your thoughts or report any issues...": "Please share your thoughts or report any issues...",
  "Contact Number": "Contact Number",
  "Feedback Type": "Feedback Type",
  "Select a feedback type": "Select a feedback type",
  "Loading...": "Loading...",
  "No feedback types available": "No feedback types available", 
  "(Optional)": "(Optional)",
  "Feedback Submitted": "Feedback Submitted",
  "Thank you for your rating!": "Thank you for your rating!",
  "Thank you for your bug report!": "Thank you for your bug report!",
  "Thank you for your idea!": "Thank you for your idea!",
  "Rating Required": "Rating Required",
  "Please select a rating before submitting.": "Please select a rating before submitting.",
  "Submit Feedback": "Submit Feedback",
  "Submitting...": "Submitting...",
  "Cancel": "Cancel",
  "Close": "Close",
  "General": "General",
  "Bug": "Bug",
  "Idea": "Idea",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Feedback Dashboard",
  "Total Feedbacks": "Total Feedbacks",
  "All-time submissions": "All-time submissions",
  "Average Rating": "Average Rating",
  "Out of 5 stars": "Out of 5 stars",
  "Feedback with Comments": "Feedback with Comments",
  "Detailed feedback": "Detailed feedback",
  "Rating Distribution": "Rating Distribution",
  "Breakdown of user satisfaction": "Breakdown of user satisfaction",
  "Rating Percentage": "Rating Percentage",
  "Proportion of each rating": "Proportion of each rating",
  "Responses": "Responses",
  "All Feedback": "All Feedback",
  "Detailed view of user submissions": "Detailed view of user submissions",
  "ID": "ID",
  "Rating": "Rating",
  "Comment": "Comment",
  "Contact": "Contact",
  "Date": "Date",
  "Page": "Page",
  "No feedback data available": "No feedback data available",
  "No comment": "No comment",
  "Not provided": "Not provided",
  "Not available": "Not available",
  
  // Authentication
  "Login": "Login",
  "Register": "Register",
  "Leen Feedback Dashboard": "Leen Feedback Dashboard",
  "Login to Dashboard": "Login to Dashboard",
  "Enter your credentials to access the admin dashboard": "Enter your credentials to access the admin dashboard",
  "Username": "Username",
  "Password": "Password",
  "Confirm Password": "Confirm Password",
  "Email": "Email",
  "Full Name": "Full Name",
  "Don't have an account?": "Don't have an account?",
  "Already have an account?": "Already have an account?",
  "Login to continue": "Login to continue",
  "Create an account": "Create an account",
  "Passwords must match": "Passwords must match",
  "Invalid email": "Invalid email",
  "Required": "Required",
  "Unauthorized": "Unauthorized",
  "You don't have permission to access this page.": "You don't have permission to access this page."
};
